import { createClient } from '@supabase/supabase-js';
import { Database } from './types';

// Use environment variables if available, otherwise fallback to the provided project credentials
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://viaurlxqgekuelmggxld.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpYXVybHhxZ2VrdWVsbWdneGxkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE1OTM5MTksImV4cCI6MjA4NzE2OTkxOX0.IssYcp47vUtsYMEvG9QcW-oCg1wKU9-JilMu-wtrkss";

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  console.error("Critical Error: Supabase credentials missing.");
  throw new Error(
    "Supabase configuration is missing. Please check your .env file (VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY) and rebuild."
  );
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);